export default __webpack_public_path__ + "static/media/BG.6c357e62.png";